import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import type { IAppointmentNoShowProps } from ".";

import { Checkbox } from "@components/atoms/checkbox";
import classes from "@components/organisms/appointmentCard/components/appointmentHelper/styles.module.scss";
import { closeAlert } from "@/stores/uiStore";
import type { INoShowTypes } from "@/api/appointment";
import { useNoShowAppointment } from "@/api/appointment";
import { useNotifyPromise } from "@/hooks";
import { showActionAlert } from "@/components/molecules/alert";
import { Icon } from "@/components/atoms/icons";
import { Typography } from "@/components/atoms/typography";

export function AppointmentNoShows({
  noShowCause,
  visitType,
  id,
  noShowType,
}: IAppointmentNoShowProps) {
  const { t } = useTranslation("form");
  const [noShow, setNoShow] = useState<INoShowTypes | undefined>(noShowCause);
  const notifyMutate = useNotifyPromise();
  const { mutateAsync } = useNoShowAppointment();

  function handleClick(noShow: INoShowTypes) {
    if (!noShowCause) {
      showActionAlert({
        title: t("no-show-confirm"),
        content: t("no-show-confirm-content"),
        onApprove() {
          notifyMutate(
            mutateAsync(
              { appointmentId: id, no_show_cause: noShow },
              {
                onSuccess: () => {
                  closeAlert();
                  setNoShow(noShow);
                },
              },
            ),
          );
        },
      });
    }
  }

  return (
    <div className={clsx(classes.noShow)}>
      {noShowType === "canceled" ? (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Icon name={"CloseCircle"} type={"bold"} color={"danger-main"} />
          <Typography variant={"caption1"} color={"primary-text"}>
            {noShowCause === "doctor-cancel"
              ? t("doctor-cancel")
              : t("patient-cancel")}
          </Typography>
        </div>
      ) : (
        <>
          <Checkbox
            title={t("doctor-no-show")}
            onChange={() => {
              handleClick("doctor-no-show");
            }}
            value={noShow === "doctor-no-show"}
          />
          <Checkbox
            title={t("patient-no-show")}
            onChange={() => handleClick("patient-no-show")}
            value={noShow === "patient-no-show"}
          />
          {visitType === "online_visit" && (
            <Checkbox
              title={t("system-caused-no-show")}
              onChange={() => handleClick("system-caused-no-show")}
              value={noShow === "system-caused-no-show"}
            />
          )}
          <Checkbox
            title={t("doctor-denied-no-show")}
            onChange={() => handleClick("doctor-denied-no-show")}
            value={noShow === "doctor-denied-no-show"}
          />
        </>
      )}
    </div>
  );
}
